import { Component } from '@angular/core';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'angular-monorepo-checkout-clinng-modal-loading',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './checkout-clinng-modal-loading.component.html',
  styleUrl: './checkout-clinng-modal-loading.component.scss',
})
export class CheckoutClinngModalLoadingComponent {
}
